import React from 'react';
import { useMatch } from 'react-router';
import { Sparkles } from 'lucide-react';
import { useAuthStore } from '@/core/stores/useAuthStore';
import { useAiChatStore } from '@/core/stores/useAiChatStore';
import { AiChatModal } from '@/screens/Store/AiChat/AiChatModal';

export const AiChatFab: React.FC = () => {
  const isAuthenticated = useAuthStore(s => s.isAuthenticated);
  const match = useMatch('/stores/:id/*');
  const analyticsMatch = useMatch('/stores/:id/analytics/*');
  const open = useAiChatStore(s => s.open);
  const setOpen = useAiChatStore(s => s.setOpen);

  // Only show on store pages where :id is available
  const storeId = match?.params.id;
  if (!isAuthenticated || !storeId) return null;

  return (
    <>
      {/* Desktop only — mobile trigger lives in StoreLayout header. */}
      {!analyticsMatch && (
        <button
          onClick={() => setOpen(true)}
          style={{ bottom: 'calc(var(--chrome-bottom-inset) + 16px)' }}
          className="ai-chat-fab hidden md:flex fixed right-6 z-50 w-12 h-12 rounded-full bg-gradient-to-br from-violet-500 to-purple-600 text-white shadow-lg shadow-violet-500/30 hover:shadow-xl hover:shadow-violet-500/40 hover:scale-105 active:scale-95 transition-all items-center justify-center"
          title="AI Chat"
        >
          <Sparkles className="w-5 h-5" />
        </button>
      )}
      <AiChatModal isOpen={open} onClose={() => setOpen(false)} storeId={storeId} />
    </>
  );
};
